import { createTheme } from '@mui/material/styles';

const temaMui = createTheme({
  palette: {
    primary: {
      main: '#0a7d33',
      dark: '#004d20',
      light: '#2fa14e',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#607d68',
      dark: '#3f5245',
      light: '#90b39a',
      contrastText: '#ffffff',
    },
    success: {
      main: '#16a360',
    },
    error: {
      main: '#f53c5b',
    },
    warning: {
      main: '#e8b210',
    },
  },
});

export default temaMui;
